<script setup lang="ts">
// Chips de gateway do saque (ENG-868), compartilhados pelas Etapas 1 e 2.
//
// O desenho (logo + nome) é do Figma; a fonte dos dados e a seleção continuam
// sendo as do fluxo antigo — allWithdrawMethods (/payments) e o
// currentWithdrawMethod do wallet store. O WithdrawMethodSelector original
// segue existindo para o fluxo antigo: ele é um carrossel só de logos, que não
// é o que este modal pede.

const { allWithdrawMethods } = usePayments();
const { isLoading: isPaymentsLoading } = storeToRefs(usePaymentsStore());
const { currentWithdrawMethod } = storeToRefs(useWalletStore());
const { selectWithdrawMethod } = useWalletStore();

// Quem garante que o método selecionado existe na lista de /payments é o casco
// (components/withdraw/Modal/index.vue): estes chips não aparecem em todas as
// telas, então a garantia não pode depender deles estarem montados.
</script>

<template>
  <div
    v-if="!isPaymentsLoading"
    class="wdm-methods"
  >
    <button
      v-for="method in allWithdrawMethods"
      :key="method.slug"
      class="wdm-method"
      :class="{ 'is-active': currentWithdrawMethod === method.slug }"
      type="button"
      @click="selectWithdrawMethod(method.slug)"
    >
      <NuxtIcon
        :filled="true"
        :name="method.icon"
      />
      <span>{{ method.title }}</span>
    </button>
  </div>
</template>

<style scoped lang="scss">
.wdm-methods {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.wdm-method {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 14px;
  border-radius: 8px;
  border: 1px solid transparent;
  background: #131a2c;
  color: #e2e3e5;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  cursor: pointer;

  // NuxtIcon ignora font-size: o logo é dimensionado pelo svg.
  :deep(svg) {
    width: 18px;
    height: 18px;
  }

  // O frame não distingue o gateway ativo (os dois chips saem idênticos); a
  // borda no accent do stepper é a marcação escolhida — ver SPEC 6.7.
  &.is-active {
    border-color: #38bdf8;
  }
}
</style>
